import AppSubMenu from './AppSubMenu';
import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GuardContext } from '../GuardContext';
import { LISTAR_DE, LISTAR_EMISOR, LISTAR_USUARIOS, REPORTE_VENTAS } from '../utilities/permission';
import { isEmpty } from 'lodash';

const AppMenu = (props) => {
    const role = useSelector((state) => state.session.rol);
    const { isOperationAllowed } = useContext(GuardContext);
    const model = useMemo(() => {
        if (!isEmpty(role)) {
            const routes = [];
            routes.push({
                label: 'Dashboards',
                icon: 'pi pi-fw pi-home',
                items: [{ label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/home' }]
            });

            //1- we verify the administration routes
            const administratorRoute = {
                label: 'Administración',
                icon: 'pi pi-fw pi-star-fill',
                items: [
                    { label: 'Emisores', icon: 'pi pi-fw pi-building', to: '/administracion/emisores' },
                    { label: 'Usuarios', icon: 'pi pi-fw pi-users', to: '/administracion/usuarios' },
                    { label: 'Documentos', icon: 'pi pi-fw pi-book', to: '/administracion/documentos' }
                ]
            };

            //Check whether there is at least one route active
            let atLeastOneRoute = false;
            for (let i = 0; i < administratorRoute.items.length; i += 1) {
                let item = administratorRoute.items[i];
                let visible = false;
                switch (item.label) {
                    case 'Emisores':
                        visible = isOperationAllowed(LISTAR_EMISOR);
                        break;
                    case 'Usuarios':
                        visible = isOperationAllowed(LISTAR_USUARIOS);
                        break;
                    case 'Documentos':
                        visible = isOperationAllowed(LISTAR_DE);
                        break;
                    default:
                        visible = false;
                }
                if (visible) {
                    atLeastOneRoute = true;
                }
                item.visible = visible;
                administratorRoute.items[i] = item;
            }
            if (atLeastOneRoute) {
                routes.push(administratorRoute);
            }

            //reuse previous flag
            atLeastOneRoute = false;
            //2- we verify the reports routes
            const reportsRoutes = {
                label: 'Reportes',
                icon: 'pi pi-fw pi-star-fill',
                items: [{ label: 'Ventas', icon: 'pi pi-fw pi-file-excel', to: '/administracion/ventas' }]
            };

            for (let i = 0; i < reportsRoutes.items.length; i++) {
                let item = reportsRoutes.items[i];
                let visible = false;
                switch (item.label) {
                    case 'Ventas':
                        visible = isOperationAllowed(REPORTE_VENTAS);
                        break;
                    default:
                        visible = false;
                }
                if (visible) {
                    atLeastOneRoute = true;
                }
                item.visible = visible;
                reportsRoutes.items[i] = item;
            }
            if (atLeastOneRoute) {
                routes.push(reportsRoutes);
            }

            return routes;
        }
        return [];
    }, [isOperationAllowed, role]);

    return <AppSubMenu model={model} />;
};

export default AppMenu;
